import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/comics';

function LatestSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              最新更新
            </h2>
            <p className="text-sm text-foreground-600">
              追更不停歇，第一时间掌握最新话更新
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {latestUpdates.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3 bg-background-100">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={`${comic.title} - 韩漫之家高清韩国漫画`}
                />
                {comic.isNew && (
                  <div className="absolute top-2.5 left-2.5">
                    <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs rounded-md font-medium">
                      NEW
                    </span>
                  </div>
                )}
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent pt-8 pb-3 px-3">
                  <p className="text-background-50 text-xs">
                    更新至 {comic.chapters} 话
                  </p>
                </div>
              </div>
              <h3 className="font-heading text-sm font-bold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500">
                {comic.author}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default LatestSection;